import { Button, Col, ListGroup, Row } from "react-bootstrap";
import { StyledPagedSearchButtonList } from "../../../../components/PaginatedSearch/styles";

interface PaginationControlsProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

export function PaginationControls({ currentPage, totalPages, onPageChange }: PaginationControlsProps) {
    if (totalPages <= 1) {
        return null;
    }

    const hasPrevious = currentPage > 1;
    const hasNext = currentPage < totalPages;

    const lowPageLimit = currentPage > 2 ? currentPage - 2 : (currentPage === 2 ? currentPage - 1 : 1);
    const highPageLimit = currentPage < totalPages - 2 ? currentPage + 2 : (currentPage === totalPages - 1 ? currentPage + 1 : totalPages);

    const buttons: JSX.Element[] = [];
    for (let i = lowPageLimit; i < highPageLimit + 1; i++) {
        buttons.push(
            <ListGroup.Item key={i}>
                <Button className={"my-auto " + (currentPage === i ? "active" : "")} onClick={() => onPageChange(i)}>
                    <p>{i}</p>
                </Button>
            </ListGroup.Item>
        );
    }

    return (
        <Row className="mt-0">
            <Col md="auto" className="mx-auto my-3">
                <StyledPagedSearchButtonList horizontal>
                    <ListGroup.Item>
                        <Button disabled={!hasPrevious} onClick={() => onPageChange(1)}>
                            <i className="bi bi-chevron-bar-left" />
                        </Button>
                    </ListGroup.Item>
                    {currentPage > 5 && (
                        <ListGroup.Item>
                            <Button onClick={() => onPageChange(currentPage - 5)}>
                                <p>-5</p>
                            </Button>
                        </ListGroup.Item>
                    )}
                    <ListGroup.Item>
                        <Button disabled={!hasPrevious} onClick={() => onPageChange(currentPage - 1)}>
                            <i className="bi bi-chevron-left" />
                        </Button>
                    </ListGroup.Item>
                    {buttons}
                    <ListGroup.Item>
                        <Button disabled={!hasNext} onClick={() => onPageChange(currentPage + 1)}>
                            <i className="bi bi-chevron-right" />
                        </Button>
                    </ListGroup.Item>
                    {totalPages - currentPage > 4 && (
                        <ListGroup.Item>
                            <Button onClick={() => onPageChange(currentPage + 5)}>
                                <p>+5</p>
                            </Button>
                        </ListGroup.Item>
                    )}
                    <ListGroup.Item>
                        <Button disabled={!hasNext} onClick={() => onPageChange(totalPages)}>
                            <i className="bi bi-chevron-bar-right" />
                        </Button>
                    </ListGroup.Item>
                </StyledPagedSearchButtonList>
            </Col>
        </Row>
    );
}
